// user.reducer
import { userConstants } from "../actions/constants";

const initState = {
  address: [],
  addressObj: {},
  error: null,
  loadingAddress: false,
  profileActionLoading: false,
  profileActionMessage: "",
  profileActionError: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case userConstants.GET_USER_ADDRESS_REQUEST:
      return {
        ...state,
        loadingAddress: true,
      };

    case userConstants.GET_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        address: action.payload.address,
        loadingAddress: false,
      };

    case userConstants.GET_USER_ADDRESS_FAILURE:
      return {
        ...state,
        loadingAddress: false,
        error: "Нет созданных адресов",
      };

    case userConstants.ADD_USER_ADDRESS_REQUEST:
      return {
        ...state,
        loadingAddress: true,
      };

    case userConstants.ADD_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        address: action.payload.address,
        addressObj: action.payload.addressObj,
        loadingAddress: false,
      };

    case userConstants.ADD_USER_ADDRESS_FAILURE:
      return {
        ...state,
        loadingAddress: false,
        error: action.payload.error,
      };

    case userConstants.USER_UPDATE_NEWSLETTER_SETTINGS_REQUEST:
    case userConstants.USER_CHANGE_PASSWORD_REQUEST:
    case userConstants.USER_EMAIL_CHANGE_REQUEST_REQUEST:
    case userConstants.USER_EMAIL_CHANGE_CONFIRM_REQUEST:
      return {
        ...state,
        profileActionLoading: true,
        profileActionMessage: "",
        profileActionError: null,
      };

    case userConstants.USER_UPDATE_NEWSLETTER_SETTINGS_SUCCESS:
    case userConstants.USER_CHANGE_PASSWORD_SUCCESS:
    case userConstants.USER_EMAIL_CHANGE_REQUEST_SUCCESS:
    case userConstants.USER_EMAIL_CHANGE_CONFIRM_SUCCESS:
      return {
        ...state,
        profileActionLoading: false,
        profileActionMessage: action.payload?.message || "",
        profileActionError: null,
      };

    case userConstants.USER_UPDATE_NEWSLETTER_SETTINGS_FAILURE:
    case userConstants.USER_CHANGE_PASSWORD_FAILURE:
    case userConstants.USER_EMAIL_CHANGE_REQUEST_FAILURE:
    case userConstants.USER_EMAIL_CHANGE_CONFIRM_FAILURE:
      return {
        ...state,
        profileActionLoading: false,
        profileActionMessage: "",
        profileActionError: action.payload?.message || action.payload?.error || "Ошибка операции",
      };

    default:
      return state;
  }
};